import Notifications from './components/Notifications'
import store from './store'

export default {
  install (Vue) {
    Vue.prototype.$notifyInfo = function (title, message, options) {
      store.addNotification({ type: 'info', title, message, ...options })
    }

    Vue.prototype.$notifyError = function (title, message, options) {
      store.addNotification({ type: 'error', title, message, ...options })
    }

    Vue.prototype.$notifySuccess = function (title, message, options) {
      store.addNotification({ type: 'success', title, message, ...options })
    }

    Vue.component('reg-notifications', Notifications)
  }
}
